<div class="table-wrapper">
  <div class="table-overflow mb-3">
    <table class="table table-striped st-table mb-0 border-border">
      <tr class="border-bottom border-border" *ngIf="showHeader">
        <th *ngFor="let column of columns">
          <div [style.max-width.px]="column.width" [style.width.px]="column.width">
            <ng-container *ngIf="column.headerTemplateRef === undefined; else customHeader">
              <div class="d-flex align-items-center">
                <span class="mr-2">{{ column.title }}</span>
                <div *ngIf="column.isSortable" class="mb-1 sort-btn" (click)="sortBy(column.key)">
                  <tr-icon *ngIf="sortingBy !== column.key" [icon]="icon.sorting"></tr-icon>
                  <tr-icon *ngIf="sortingBy === column.key && sortDirection === 'ASC'" [icon]="icon.sortableUp"></tr-icon>
                  <tr-icon *ngIf="sortingBy === column.key && sortDirection === 'DESC'" [icon]="icon.sortableDown"></tr-icon>
                </div>
              </div>
            </ng-container>
            <ng-template #customHeader>
              <ng-container *ngTemplateOutlet="column.headerTemplateRef; context: { column }"></ng-container>
            </ng-template>
          </div>
        </th>
      </tr>

      <tr *ngFor="let item of data; trackBy: trackById" [ngClass]="customRowClass">

        <ng-container *ngFor="let column of columns; let i = index">
          <td *ngIf="column.dataType === dataType.string" [ngClass]="customCellClass">
            <div [style.max-width.px]="column.width" [style.width.px]="column.width">
              <span [ngClass]="column.isLink ? 'link color-info' : ''">{{ item[column.key] }}</span>
            </div>
          </td>

          <td *ngIf="column.dataType === dataType.date" [ngClass]="customCellClass">
            <div [style.max-width.px]="column.width" [style.width.px]="column.width">
              <span *ngIf="item[column.key] !== undefined && item[column.key] !== null; else emptyCell">{{ item[column.key] | trDateFormat: 'MM/DD/YYYY HH:mm': timezone }}</span>
            </div>
          </td>

          <td *ngIf="column.dataType === dataType.number" [ngClass]="customCellClass">
            <div [style.max-width.px]="column.width" [style.width.px]="column.width">
              <span>{{ item[column.key] === undefined ? '-' : item[column.key] }}</span>
            </div>
          </td>

          <td *ngIf="column.dataType === dataType.toggle" [ngClass]="customCellClass">
            <div [style.max-width.px]="column.width" [style.width.px]="column.width">
              <tablesready-switcher
                [id]="item._id + column.key"
                [(ngModel)]="item[column.key]"
                (ngModelChange)="column?.toggleCallback(item, column.key)"
              ></tablesready-switcher>
            </div>
          </td>

          <td *ngIf="column.dataType === dataType.custom" [ngClass]="customCellClass">
            <div [style.max-width.px]="column.width" [style.width.px]="column.width">
              <ng-container *ngTemplateOutlet="column.cellTemplateRef; context: { item, index: i }"></ng-container>
            </div>
          </td>
        </ng-container>
      </tr>
    </table>
  </div>

  <div class="d-flex flex-row justify-content-end" *ngIf="enablePagination">
    <div class="paginator">
      <ngb-pagination
        *ngIf="dataSource"
        [(page)]="dataSource.page"
        [pageSize]="dataSource.pageSize"
        [maxSize]="dataSource.maxDisplayPages"
        [ellipses]="true"
        [collectionSize]="dataSource.total"
        (pageChange)="loadData(this.lastParams, false)"
      ></ngb-pagination>
    </div>
  </div>
</div>

<ng-template #emptyCell>
  <span>-</span>
</ng-template>
